import { define } from 'wicked-elements'

const LOGOWIDE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1460 74" role="img" alt="">
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
    </style>
  </defs>
  <g>
    <rect class="cls-1" width="1460" height="74"/>
    <g id="story" class="trigger-peachred">
      <path d="M1458,30.2V4.75h-21.52V28.69c0,3.56-1.89,5.15-5.45,5.15h-7.65c-3.18,0-5.15-1.44-5.15-5.15V4.75h-21.44V30.2c0,13.87,4.39,21.9,18.63,23.72V66.57h23V54C1453.38,52.1,1458,43.39,1458,30.2"/>
      <path d="M1388.19,42c2.65-2.88,4.09-6.75,4.09-11.67V26.64c0-17-7.81-21.89-20.91-21.89H1333V66.57h23.11V50.89h8.71c3.19,0,4.55,1.36,4.55,4.47V66.57h23V53.31C1392.43,48,1391.29,44.3,1388.19,42Zm-18.41-12.12c0,1.89-1.14,3.48-4.55,3.48h-9.09V25.13h9.09c3.34,0,4.55,1.06,4.55,4Z"/>
      <path d="M1300.31,4.37h-8c-21.82,0-26.9,5.83-26.9,26.59v9.32c0,20.83,5.08,26.59,26.9,26.59h8c21.75,0,27.2-5.76,27.2-26.59V31C1327.51,10.2,1320.54,4.37,1300.31,4.37Zm4.62,35.15c0,4.25-1.59,7.2-7.12,7.2h-3c-5.53,0-7.12-1.89-7.12-7.2V31.34c0-5.38,2.65-7.12,7.12-7.12h3c5.53,0,7.12,2.8,7.12,7.12Z"/>
      <polygon points="1261.87 24.9 1261.87 4.75 1201.18 4.75 1201.18 24.9 1220.5 24.9 1220.5 66.57 1243.61 66.57 1243.61 24.9 1261.87 24.9"/>
      <path d="M1199.92,47.63V43.69c0-9.09-6.6-15.91-19.17-15.91h-16.82c-1.36,0-1.74-.76-1.74-1.67v-.3c0-.83.53-1.44,1.74-1.44h31.89V4.75H1160c-13.56,0-21.52,5.3-21.52,19.09V26c0,11.89,6.06,18.18,21.37,18.18h15.07c1,0,1.52.38,1.52,1.44v.23c0,1-.38,1.44-1.52,1.44h-35.22V66.49h39.85c14.77,0,20.38-8.78,20.38-18.86"/>
    </g>
    <g id="story-jp" class="trigger-rawsienna">
      <rect x="1041.5" y="25.28" width="64.93" height="22.58"/>
      <rect x="969.75" y="4.6" width="22.27" height="38.71"/>
      <path d="M1034.67,31.57V4.6h-22.35V31.19c0,12.88-4.39,17.2-15.53,17.2H978v22h19.48c23.71,0,37.19-8.1,37.19-38.86"/>
      <rect x="898.03" y="25.28" width="64.93" height="22.58"/>
      <path d="M890.55,51.49V29.22h-9.47c-17.42,0-29.24-2.5-29.24-9.7V3.76H828.58V70.43h23.26V47.55c7.65,2.65,17.42,3.94,29.24,3.94Z"/>
      <path d="M823.25,70.28v-22a39.41,39.41,0,0,1-14.84-2.43,45.14,45.14,0,0,0,6.66-23.18V6H755.83V26.11h35.91V27.7c0,6.22-8.41,21-38.34,21V71c16.75,0,29.32-3.71,38.72-9.24,8.56,5.91,14.09,8.56,31.13,8.56"/>
    </g>
    <g id="dot" class="trigger-dot">
      <path d="M729.62,37.63a32.89,32.89,0,1,0-32.89,32.88,33,33,0,0,0,32.89-32.88"/>
    </g>
    <g id="japan-jp" class="trigger-antwarpblue">
      <path d="M639.91,30.2V5.88c-17.42,2.05-21.81,9-25.45,27.13-2,10-5.76,15.91-25.61,15.91H570.59V70.28H591.5c27.43,0,41.67-10.6,45.08-35.68.3-2.2,1.06-3.79,3.33-4.4"/>
      <rect x="570.82" y="6.79" width="31.36" height="21.14"/>
      <path d="M558.77,36.87V21.26c5.83-.53,8.94-3.86,8.94-10.3,0-7-3.49-10.3-10.69-10.3-4.39,0-7.42,1.21-9.16,3.71H537.17v32c0,20.76,9.55,32.81,28.94,35V47.63C560.74,46.64,558.77,43.16,558.77,36.87Zm-4.4-26.14c0-1.81.84-2.5,2.65-2.5s2.5.69,2.5,2.5c0,2.12-.75,2.73-2.5,2.73S554.37,12.85,554.37,10.73Z"/>
      <path d="M524.9,36.34v-32H503.31v32.5c0,6.29-1.74,9.62-7.35,10.76V71.34c19.47-2.19,28.94-14.24,28.94-35"/>
      <path d="M490.18,34.67V20.81H455.71l-.15-3.94h-17.2l.08,3.94h-5.16V37.86H439l1.21,32.8h17.13l-1.06-32.8h16.36v1.51c0,4.09-1,5.38-6.36,5.38h-6.9V62.18h6.9c18.63,0,23.86-7.43,23.86-27.51"/>
      <rect x="357.93" y="26.64" width="33.33" height="17.95"/>
      <path d="M426.72,26.64v-.3H403.16a9.34,9.34,0,0,0-1.51,4.17c-2.35,13.33-8.19,19.32-26.82,19.32H357V70.28H377.4c34.17,0,43.11-14.62,46.52-36.52.61-4.09,1.67-6.36,2.8-7.12"/>
      <rect x="357.93" y="5.73" width="33.33" height="18.03"/>
      <rect x="408.77" y="15.2" width="18.41" height="8.56"/>
      <rect x="408.77" y="3.69" width="18.41" height="8.64"/>
    </g>
    <g id="Japan" class="trigger-taupebrown">
      <path d="M325.28,48.16V4.9h-21V39.07c0,.83-.3,1.06-.6,1.06-.46,0-.61-.23-.76-1.06l-7.58-21.9c-2.12-6.13-6.28-12.8-17.19-12.8-10.23,0-17.58,6.29-17.58,18.71V66.57h20.91V32.48c0-.68.15-1,.45-1s.46.23.61.91l7.27,19.47c3.26,8.71,8.41,15.38,18.19,15.38,10.68,0,17.27-5.83,17.27-19.09"/>
      <path d="M229.46,3.61h-8.41c-20,0-24.32,6.44-24.32,25.23V66.57h21.59V57.25h15v9.32h21.44V28.84C254.76,10.05,249.46,3.61,229.46,3.61Zm3.86,33.94h-15V28.84c0-3.94.61-5.08,4-5.08h6.89c3.49,0,4.09,1.14,4.09,5.08Z"/>
      <path d="M170.49,4.75h-39.4V66.57h22.5V53.92h16.74c14.78,0,21.14-8.79,21.14-21.75V27.25C191.47,10.81,183,4.75,170.49,4.75Zm-1.67,25.08c0,2.72-1.29,3.63-4.55,3.63H153.59V25h10.68c3.34,0,4.55.45,4.55,4.16Z"/>
      <path d="M99.73,3.61H91.32C71.32,3.61,67,10.05,67,28.84V66.57H88.59V57.25h15v9.32H125V28.84C125,10.05,119.73,3.61,99.73,3.61Zm3.87,33.94h-15V28.84c0-3.94.61-5.08,4-5.08h6.9c3.48,0,4.09,1.14,4.09,5.08Z"/>
      <path d="M62.31,42.1V4.75H39.05V40.28c0,4.85-2,5.91-6,5.91H28.59c-2.42,0-3.56-.76-3.56-3.26V33.46H2V46c0,13.56,8.11,20.61,24.09,20.61H38.14c15.76,0,24.17-9.32,24.17-24.47"/>
    </g>
  </g>
</svg>
`

const LOGOSTACK = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 738 152" role="img" alt="">
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
    </style>
  </defs>
  <g>
    <rect class="cls-1" width="738" height="152"/>
    <g id="story" class="trigger-peachred">
      <path d="M738.89,108.52V83.06H717.37V107c0,3.56-1.89,5.15-5.45,5.15h-7.65c-3.19,0-5.15-1.44-5.15-5.15V83.06H677.67v25.46c0,13.86,4.4,21.89,18.64,23.71v12.65h23V132.31c14.93-1.9,19.55-10.61,19.55-23.79"/>
      <path d="M669,120.26c2.66-2.88,4.1-6.74,4.1-11.67V105c0-17-7.81-21.9-20.91-21.9H613.8v61.82h23.11V129.2h8.71c3.18,0,4.55,1.36,4.55,4.47v11.21h23V131.62C673.2,126.32,672.06,122.61,669,120.26Zm-18.4-12.12c0,1.89-1.14,3.48-4.55,3.48h-9.09v-8.18H646c3.33,0,4.55,1.06,4.55,4Z"/>
      <path d="M581,82.68h-8c-21.82,0-26.9,5.84-26.9,26.6v9.31c0,20.84,5.08,26.6,26.9,26.6h8c21.74,0,27.2-5.76,27.2-26.6v-9.31C608.16,88.52,601.19,82.68,581,82.68Zm4.62,35.16c0,4.24-1.59,7.19-7.12,7.19h-3c-5.53,0-7.13-1.89-7.13-7.19v-8.19c0-5.38,2.66-7.12,7.13-7.12h3c5.53,0,7.12,2.81,7.12,7.12Z"/>
      <polygon points="542.4 103.22 542.4 83.06 481.71 83.06 481.71 103.22 501.03 103.22 501.03 144.88 524.14 144.88 524.14 103.22 542.4 103.22"/>
      <path d="M480.32,125.94V122c0-9.09-6.59-15.91-19.17-15.91H444.33c-1.36,0-1.74-.75-1.74-1.66v-.31c0-.83.53-1.44,1.74-1.44h31.9V83.06H440.39c-13.56,0-21.51,5.3-21.51,19.09v2.2c0,11.89,6.06,18.18,21.36,18.18h15.08c1,0,1.52.38,1.52,1.44v.23c0,1-.38,1.44-1.52,1.44H420.09v19.17h39.85c14.77,0,20.38-8.79,20.38-18.87"/>
    </g>
    <g id="story-jp" class="trigger-rawsienna">
      <rect x="313.58" y="103.59" width="64.93" height="22.58"/>
      <rect x="235.95" y="82.91" width="22.27" height="38.71"/>
      <path d="M300.88,109.88v-27H278.53V109.5c0,12.88-4.39,17.2-15.53,17.2H244.21v22h19.47c23.72,0,37.2-8.11,37.2-38.87"/>
      <rect x="158.37" y="103.59" width="64.93" height="22.58"/>
      <path d="M145,129.81V107.53h-9.47c-17.43,0-29.25-2.5-29.25-9.69V82.08H83v66.67H106.3V125.87c7.65,2.65,17.43,3.94,29.25,3.94Z"/>
      <path d="M71.85,148.59v-22A39.23,39.23,0,0,1,57,124.12a45.11,45.11,0,0,0,6.66-23.18V84.27H4.42v20.16H40.33V106c0,6.21-8.41,21-38.33,21v22.28c16.74,0,29.31-3.72,38.71-9.25,8.56,5.91,14.09,8.56,31.14,8.56"/>
    </g>
    <g id="dot" class="trigger-dot">
      <path id="dot" d="M736.16,37.81a32.88,32.88,0,1,0-32.88,32.88,32.95,32.95,0,0,0,32.88-32.88"/>
    </g>
    <g id="japan-jp" class="trigger-antwarpblue">
      <path d="M643.58,30.39V6.07c-17.42,2-21.82,9-25.45,27.12-2,10-5.76,15.91-25.61,15.91H574.26V70.47h20.91c27.43,0,41.67-10.61,45.08-35.69.3-2.19,1.06-3.78,3.33-4.39"/>
      <rect x="574.49" y="6.98" width="31.37" height="21.14"/>
      <path d="M562.33,37.06V21.45c5.83-.53,8.94-3.86,8.94-10.3,0-7-3.49-10.31-10.68-10.31-4.4,0-7.43,1.21-9.17,3.71H540.74v32c0,20.75,9.54,32.8,28.94,35V47.81C564.3,46.83,562.33,43.34,562.33,37.06Zm-4.4-26.14c0-1.82.84-2.5,2.66-2.5,1.66,0,2.5.68,2.5,2.5,0,2.12-.76,2.73-2.5,2.73S557.93,13,557.93,10.92Z"/>
      <path d="M528.46,36.53v-32H506.87V37.06c0,6.28-1.74,9.62-7.35,10.75V71.53c19.47-2.2,28.94-14.25,28.94-35"/>
      <path d="M493.6,34.86V21H459.13L459,17.06h-17.2l.07,3.94H436.7V38h5.76l1.21,32.81h17.12L459.73,38H476.1v1.52c0,4.09-1,5.38-6.37,5.38h-6.89V62.36h6.89c18.64,0,23.87-7.42,23.87-27.5"/>
      <rect x="361.21" y="26.83" width="33.33" height="17.96"/>
      <path d="M430,26.83v-.3H406.44a9.46,9.46,0,0,0-1.51,4.16C402.58,44,396.75,50,378.11,50H360.3V70.47h20.38c34.17,0,43.11-14.63,46.52-36.52.61-4.09,1.67-6.36,2.8-7.12"/>
      <rect x="361.21" y="5.92" width="33.33" height="18.03"/>
      <rect x="412.05" y="15.39" width="18.41" height="8.56"/>
      <rect x="412.05" y="3.87" width="18.41" height="8.64"/>
    </g>
    <g id="japan" class="trigger-taupebrown">
      <path d="M325.68,48.34V5.09h-21V39.25c0,.84-.31,1.06-.61,1.06s-.61-.22-.76-1.06l-7.57-21.89c-2.13-6.14-6.29-12.81-17.2-12.81C268.33,4.55,261,10.84,261,23.27V66.75h20.91V32.66c0-.68.15-1,.46-1s.45.22.6.91l7.28,19.47c3.25,8.71,8.41,15.38,18.18,15.38,10.68,0,17.27-5.84,17.27-19.1"/>
      <path d="M229.74,3.8h-8.41C201.33,3.8,197,10.24,197,29V66.75H218.6V57.44h15v9.31H255V29C255,10.24,249.74,3.8,229.74,3.8Zm3.86,33.94h-15V29c0-3.94.61-5.08,4-5.08h6.89c3.49,0,4.09,1.14,4.09,5.08Z"/>
      <path d="M170.64,4.93h-39.4V66.75h22.5V54.1h16.75c14.77,0,21.13-8.79,21.13-21.74V27.43C191.62,11,183.14,4.93,170.64,4.93ZM169,30c0,2.73-1.29,3.64-4.54,3.64H153.74V25.16h10.69c3.33,0,4.54.46,4.54,4.17Z"/>
      <path d="M99.76,3.8H91.35C71.35,3.8,67,10.24,67,29V66.75h21.6V57.44h15v9.31h21.44V29C125.07,10.24,119.76,3.8,99.76,3.8Zm3.87,33.94h-15V29c0-3.94.6-5.08,4-5.08h6.9c3.48,0,4.09,1.14,4.09,5.08Z"/>
      <path d="M62.22,42.28V4.93H39V40.47c0,4.84-2,5.9-6,5.9H28.51c-2.42,0-3.56-.75-3.56-3.25V33.65h-23v12.5C1.92,59.71,10,66.75,26,66.75H38.06c15.76,0,24.16-9.31,24.16-24.47"/>
    </g>
  </g>
</svg>
`

define('[data-component~="logo-swapper"]', {
  init () {
    this.handleResize = this.handleResize.bind(this)
    this.throttled = null
  },
  connected () {
    this.render()
    window.addEventListener('resize', this.handleResize)
  },
  disconnected () {
    window.removeEventListener('resize', this.handleResize)
  },
  handleResize () {
    clearTimeout(this.throttled)
    this.throttled = setTimeout(() => {
      this.render()
    }, 100)
  },
  render () {
    if (window.innerWidth < 768) {
      this.element.innerHTML = LOGOSTACK  
    } else {
      this.element.innerHTML = LOGOWIDE
    }
  }
})